import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Logo from '../../../assets/logo.png';
import { getStrLang } from '../../Translate';
import 'jquery-ui-dist/jquery-ui';
import { getDeposit,updateDepositWallet } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import $ from 'jquery';
import Timer from '../../Timer';
import { MDBContainer, MDBModal, MDBModalHeader, MDBModalBody } from 'mdbreact';
import PixDefault from '../../pixComponentes/pixDefault';
import Crypto from '../Crypto'
import './USDtPIX.css'; // Importing custom CSS for better styling
import UsdtLogo from '../../../assets/usdt.png'
import PixIcon from '../../../assets/logo-pix.png';
import crypto from 'crypto'
import { IoChevronBackOutline } from 'react-icons/io5';

let timeoutId = null;

// code to generate random usdt wallet
const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
const ALPHABET_MAP = {};
for (let i = 0; i < ALPHABET.length; i++) {
    ALPHABET_MAP[ALPHABET.charAt(i)] = i;
}
const base58Encode = (buffer) => {
    let carry;
    const digits = [0];
    for (let i = 0; i < buffer.length; i++) {
        carry = buffer[i];
        for (let j = 0; j < digits.length; j++) {
            carry += digits[j] << 8;
            digits[j] = carry % 58;
            carry = (carry / 58) | 0;
        }
        while (carry) {
            digits.push(carry % 58);
            carry = (carry / 58) | 0;
        }
    }
    let result = '';
    for (let k = 0; k < buffer.length && buffer[k] === 0; k++) {
        result += ALPHABET[0];
    }
    for (let q = digits.length - 1; q >= 0; q--) {
        result += ALPHABET[digits[q]];
    }
    return result;
};
const generateRandomWalletAddress = () => {
    const prefix = Buffer.from([0x41]);
    const address = crypto.randomBytes(20);
    const addressWithPrefix = Buffer.concat([prefix, address]);

    const hash = crypto.createHash('sha256').update(addressWithPrefix).digest();
    const checksum = crypto.createHash('sha256').update(hash).digest().slice(0, 4);

    const fullAddress = Buffer.concat([addressWithPrefix, checksum]);
    return base58Encode(fullAddress);
};

const USDtPIX = (props) => {
    const { translate, lang } = useLanguage();
    const [expirado, setExpirado] = useState(false);
    const [modal, setModal] = useState(false);
    const [mensagem, setMensagem] = useState({});
    const [walletInfo, setWalletInfo] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [telaPix, setTelaPix] = useState("default");
    const [agreeTerm,setAgreeTerm]=useState(false)

    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);

    useEffect(() => {
        translate();
    }, [translate]);

    const toggleModal = () => {
        setModal(!modal);
        if(selectedOption==="pix"){
            setSelectedOption(null)
        }
    };
    const agreeTermAction = ()=>{
        setAgreeTerm(true)
        setModal(!modal);
    }

    useEffect(()=>{
        const wallet_address=generateRandomWalletAddress()
        setWalletInfo(wallet_address)
        try{
            updateDepositWallet(sessionStorage.getItem("order_no"),wallet_address)
        }catch(e){}
    },[])

    function handleOptionSelect(option) {
        setSelectedOption(option);
        if (option === 'pix') {
            handlePayWithPix();
            props.setCurrentMethod('usdtpix')
        }else{
            props.setCurrentMethod('crypto')
        }
    }

    function handlePayWithPix() {
        setMensagem({
            msg1: getStrLang(lang.nameLang, "agreement_title"),
            msg2: getStrLang(lang.nameLang, "agreement_msg1"),
            msg3: getStrLang(lang.nameLang, "agreement_msg2") + " " + sessionStorage.getItem("client_name"),
            msg4: getStrLang(lang.nameLang, "agreement_confirmation")
        });
        setModal(true);
    }

    useEffect(() => {
        function doEffect() {
            let ctrl = $("#message-pix span");
            $(ctrl).css("display", "flex");
            $(ctrl).fadeIn(500, function () {
                ctrl.effect("pulsate", 15000).fadeOut(500);
                doEffect(ctrl);
            });
        }

        function checkPayment() {
            console.log('checkPayment pix')
            timeoutId = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            doEffect();
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
                console.log('Timeout cleared');
                timeoutId=null;
            }
        };
    }, [waitingPayment]);

    return (
        <div className="usdtpix-container">
            <div className="usdtpix-content">
                {selectedOption === null && (
                    <div className="wallet-info-section">
                        <div className="wallet-info">
                            <label>TRON Wallet Address</label>
                            <div className="wallet-address">{walletInfo}</div>
                        </div>
                        <div className="payment-options">
                            <button onClick={() => handleOptionSelect('pix')} className="btn btn-primary">
                                <img src={PixIcon} alt='pix' width="16px" height="16px" style={{ marginRight: "0.5em", marginBottom: "0.2em" }} /> Pay with Pix
                            </button>
                            <button onClick={() => handleOptionSelect('crypto')} className="btn btn-primary">
                                <img src={UsdtLogo} alt='usdt' width="16px" height="16px" style={{ marginRight: "0.5em", marginBottom: "0.2em" }} /> Pay with Crypto
                            </button>
                        </div>
                    </div>
                )}
                {selectedOption !== null &&   <div className="column-pix-sides">
                    <button className="btn-split-pix" onClick={() => {setSelectedOption(null);setAgreeTerm(false);}}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
                </div>}
                {selectedOption === 'crypto' && (
                    <div className="pix-payment-section">
                        <Crypto setShowTermos={props.setShowTermos} isUsdtPixPayment={true}  provider={props.usdtprovider}/>
                    </div>
                )}
                {selectedOption === 'pix' && (<>
                {agreeTerm ===true ? <div className="pix-payment-section">
                        {props.pix_time_limit === "true" && <Timer countdown={60} setExpirado={setExpirado} />}
                        {!expirado && props.pix_time_limit === "true" ?
                            <div id='message-pix' className='infoarea-pix-message'>
                                <span data-lang-str="waiting-payment-pix"></span>
                            </div> : <div id='message-pix' className='infoarea-pix-message'>
                                <span data-lang-str="waiting-payment-pix"></span>
                            </div>
                        }

                        {props.pix_time_limit === "true" ?
                            <>
                                {!expirado && (
                                    <div className="qr-code-container">
                                        <PixDefault setWaitingPayment={setWaitingPayment} setShowTermos={props.setShowTermos} setTelaPix={setTelaPix} hideSplit={true} isUsdtPixPayment={true}/>
                                    </div>
                                )}
                            </> : <>
                                <div className="qr-code-container">
                                    <PixDefault setWaitingPayment={setWaitingPayment} setShowTermos={props.setShowTermos} setTelaPix={setTelaPix} hideSplit={true} isUsdtPixPayment={true}/>
                                </div>
                            </>
                        }
                    </div>:<>
                    
                    </>}
                
                </>

                )}

                {modal &&
                    <MDBContainer>
                        <MDBModal isOpen={modal} toggle={toggleModal} backdrop={false} keyboard={false}>
                            <MDBModalHeader toggle={toggleModal}>{mensagem.msg1}</MDBModalHeader>
                            <MDBModalBody>
                                <p style={{ textAlign: 'center' }}>
                                    {mensagem.msg2}<br />
                                    {mensagem.msg3}<br /><br />
                                    {mensagem.msg4}
                                </p>
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <button onClick={agreeTermAction} className="btn btn-primary">
                                        OK
                                    </button>
                                </div>
                            </MDBModalBody>
                        </MDBModal>
                    </MDBContainer>


                }
            </div>
        </div>
    )
}

export default USDtPIX;
